import * as SeparatorPrimitive from "@radix-ui/react-separator";

import { cn, platformProps } from "../../lib";
import type { SeparatorProps } from "./types";

function Separator({
  className,
  orientation = "horizontal",
  decorative = true,
  testID,
  ...rest
}: SeparatorProps) {
  return (
    <SeparatorPrimitive.Root
      {...platformProps({ testID, slot: "separator" })}
      decorative={decorative}
      orientation={orientation}
      className={cn(
        "shrink-0",
        orientation === "horizontal" ? "h-px w-full" : "w-px self-stretch",
        className,
      )}
      // A caller's own platformProps (Divider's data-slot) override the defaults
      {...rest}
    />
  );
}

export { Separator };
